import {
  Confirmation,
  RedCardAttribute,
  SoccerIncidentId,
} from '@collector/sportsapi-client-legacy'
import AttributesSelection from '@mobile/views/Relation/Shared/Popup/builder/AttributesSelection.vue'
import { useCancellationButton } from '@mobile/views/Relation/Shared/Popup/builder/buttons/useCancellationButton'
import { useCloseButton } from '@mobile/views/Relation/Shared/Popup/builder/buttons/useCloseButton'
import { useConfirmationButton } from '@mobile/views/Relation/Shared/Popup/builder/buttons/useConfirmationButton'
import { useNavigationSeparator } from '@mobile/views/Relation/Shared/Popup/builder/buttons/useNavigationSeparator'
import { usePopupButton } from '@mobile/views/Relation/Shared/Popup/builder/buttons/usePopupButton'
import { PopupBuilder } from '@mobile/views/Relation/Shared/Popup/builder/PopupBuilder'
import SelectedParticipant from '@mobile/views/Relation/Shared/Popup/builder/SelectedParticipant.vue'
import { PopupContext } from '@mobile/views/Relation/Shared/Popup/builder/types'

import { VARPopup } from '../VAR/VARPopup'

export const RedCardPopup = new PopupBuilder('Red Card', {
  incident_id: SoccerIncidentId.RedCard,
  confirmation: Confirmation.ToBeDone,
})
  .withTeamSelection()
  .setNavigationButtons([
    usePopupButton({
      props: {
        text: 'VAR',
        color: 'blue',
        onClick: (context: PopupContext | null) => context?.openPopup(VARPopup),
        attributes: { 'data-cy': 'redCardDetailsVARButton' },
      },
    }),
    ...useNavigationSeparator(2),
    useCloseButton(),
    useCancellationButton(),
    useConfirmationButton(),
  ])
  .appendBody(SelectedParticipant)
  .appendBody(AttributesSelection, {
    title: 'Additional info',
    attributes: [RedCardAttribute.SecondYellowCard, RedCardAttribute.OffField],
    multiselect: true,
    withNoneAttribute: false,
  })
  .build()
